import { cn, colors } from "tools/ui";

function BooleanCell(props) {
  // let parentStore = useMainStore.getState();
  // const { save: saveParent, reload: reloadParent } = parentStore;
  // const { store, updateStore } = mainStore();
  const { onChange, name, color, editable, data, record, parentRec, readOnly } =
    props;

  function handleChange(event) {
    const _value = event.target.value;
    data.value = !data.value;
    onChange();
    // TODO: review this for save in upStore
    // if (parentRec) {
    //   const _store = store;
    //   const field_ = field.name;
    //   _store[parentRec.fieldName] = [
    //     [
    //       "write",
    //       [record.id],
    //       {
    //         [field_]: data.value,
    //       },
    //     ],
    //   ];
    //   updateStore({ ..._store });
    //   await saveParent();
    //   await reloadParent();
    // }
  }

  const _color = readOnly ? colors.readOnly : (color ?? "bg-white");

  return (
    <input
      id={name}
      name={name}
      className={cn("h-5 w-5 rounded-full", _color)}
      type="checkbox"
      inputMode="numeric"
      value={data.value}
      checked={data.value || false}
      onChange={handleChange}
      disabled={readOnly || !editable}
    />
  );
}

export default BooleanCell;
